export interface UserSettings {
  id: string;
  user_id: string;
  llm_provider: string | null;
  model_name: string | null;
  has_api_key: boolean;
  created_at: string;
  updated_at: string;
}

export interface LLMProvider {
  id: string;
  name: string;
  models: string[];
  requiresApiKey: boolean;
}

export const LLM_PROVIDERS: LLMProvider[] = [
  {
    id: "grok",
    name: "Grok (xAI)",
    models: ["grok-beta", "grok-2-1212"],
    requiresApiKey: true,
  },
  {
    id: "openai",
    name: "OpenAI",
    models: ["gpt-4", "gpt-4-turbo", "gpt-3.5-turbo"],
    requiresApiKey: true,
  },
  {
    id: "anthropic",
    name: "Anthropic",
    models: ["claude-3-5-sonnet-20241022", "claude-3-opus-20240229"],
    requiresApiKey: true,
  },
  {
    id: "google",
    name: "Google",
    models: ["gemini-pro", "gemini-1.5-pro"],
    requiresApiKey: true,
  },
];
